import { createRouteRef } from '@backstage/frontend-plugin-api';

export const securityRouteRef = createRouteRef();
